import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { setupAxios } from "./utils/axiosInstance";
import { useLoader } from "./context/LoaderContext";
import { lazyPage } from "./utils/routeLazy";
import Login from "./pages/Login";
import SetupPassword from "./pages/SetupPassword";
import ProtectedRoute from "./components/ProtectedRoute";
import GlobalLoader from "./components/GlobalLoader";

const SuperAdminDashboard = lazyPage(() => import("./pages/superadmin/Dashboard"));
const SuperAdminSchools = lazyPage(() => import("./pages/superadmin/Schools"));
const SchoolDashboard = lazyPage(() => import("./pages/schooladmin/Dashboard"));
const Teachers = lazyPage(() => import("./pages/schooladmin/Teachers"));
const Students = lazyPage(() => import("./pages/schooladmin/Students"));
const SchoolProfile = lazyPage(() => import("./pages/schooladmin/SchoolProfile"));
const SchoolFees = lazyPage(() => import("./pages/schooladmin/Fees"));
const SchoolResults = lazyPage(() => import("./pages/schooladmin/Results"));
const SchoolReports = lazyPage(() => import("./pages/schooladmin/Reports"));
const StudentDocuments = lazyPage(() => import("./pages/schooladmin/StudentDocuments"));
const SchoolClasses = lazyPage(() => import("./pages/schooladmin/Classes"));
const SchoolAttendance = lazyPage(() => import("./pages/schooladmin/Attendance"));
const TeacherDashboard = lazyPage(() => import("./pages/Teacher/TeacherDashboard"));
const StudentDashboard = lazyPage(() => import("./pages/Student/StudentDashboard"));
const AllStudents = lazyPage(() => import("./pages/Teacher/AllStudents"));
const TeacherAttendance = lazyPage(() => import("./pages/Teacher/Attendance"));
const StudentProfile = lazyPage(() => import("./pages/Student/StudentProfile"));
const TeacherProfile = lazyPage(() => import("./pages/Teacher/TeacherProfile"));
const HelpCenter = lazyPage(() => import("./pages/HelpCenter"));

function App() {
  const loader = useLoader();

  useEffect(() => {
    setupAxios({ startRequest: loader.startRequest, endRequest: loader.endRequest });
  }, [loader.startRequest, loader.endRequest]);

  return (
    <BrowserRouter>
      <GlobalLoader />
      <Routes>

        <Route path="/" element={<Login />} />


        <Route path="/setup-password/:token" element={<SetupPassword />} />


        {/* SUPER ADMIN */}
        <Route
          path="/superadmin/dashboard"
          element={
            <ProtectedRoute role="SUPER_ADMIN">
              <SuperAdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/superadmin/schools"
          element={
            <ProtectedRoute role="SUPER_ADMIN">
              <SuperAdminSchools />
            </ProtectedRoute>
          }
        />

        {/* SCHOOL ADMIN */}
        <Route
          path="/schooladmin/dashboard"
          element={
            <ProtectedRoute role="SCHOOL_ADMIN">
              <SchoolDashboard />
            </ProtectedRoute>
          }
        />
        {/* TEACHER DASHBOARDS - PLACEHOLDERS */}
        <Route
          path="/schooladmin/teachers"
          element={
            <ProtectedRoute role="SCHOOL_ADMIN">
              <Teachers />
            </ProtectedRoute>
          }
        />
        <Route
          path="/schooladmin/classes"
          element={
            <ProtectedRoute role="SCHOOL_ADMIN">
              <SchoolClasses />
            </ProtectedRoute>
          }
        />
        <Route
          path="/schooladmin/attendance"
          element={
            <ProtectedRoute role="SCHOOL_ADMIN">
              <SchoolAttendance />
            </ProtectedRoute>
          }
        />

        <Route path="/teacher/dashboard" element={
          <ProtectedRoute role="TEACHER">
            <TeacherDashboard />
          </ProtectedRoute>
        } />
        <Route
          path="/teacher/allstudents"
          element={
            <ProtectedRoute role="TEACHER">
              <AllStudents />
            </ProtectedRoute>
          }
        />
        <Route
          path="/teacher/attendance"
          element={
            <ProtectedRoute role="TEACHER">
              <TeacherAttendance />
            </ProtectedRoute>
          }
        />
        <Route
          path="/teacher/profile"
          element={
            <ProtectedRoute role="TEACHER">
              <TeacherProfile />
            </ProtectedRoute>
          }
        />
        {/* STUDENT DASHBOARDS - PLACEHOLDERS */}
        <Route
          path="/schooladmin/students"
          element={
            <ProtectedRoute role="SCHOOL_ADMIN">
              <Students />
            </ProtectedRoute>
          }
        />
        <Route
          path="/schooladmin/profile"
          element={
            <ProtectedRoute role="SCHOOL_ADMIN">
              <SchoolProfile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/schooladmin/fees"
          element={
            <ProtectedRoute role="SCHOOL_ADMIN">
              <SchoolFees />
            </ProtectedRoute>
          }
        />
        <Route
          path="/schooladmin/results"
          element={
            <ProtectedRoute role="SCHOOL_ADMIN">
              <SchoolResults />
            </ProtectedRoute>
          }
        />
        <Route
          path="/schooladmin/reports"
          element={
            <ProtectedRoute role="SCHOOL_ADMIN">
              <SchoolReports />
            </ProtectedRoute>
          }
        />
        <Route
          path="/schooladmin/documents"
          element={
            <ProtectedRoute role="SCHOOL_ADMIN">
              <StudentDocuments />
            </ProtectedRoute>
          }
        />
        <Route path="/student/dashboard" element={
          <ProtectedRoute role="STUDENT">
            <StudentDashboard />
          </ProtectedRoute>
        } />
        <Route path="/student/profile" element={
          <ProtectedRoute role="STUDENT">
            <StudentProfile />
          </ProtectedRoute>
        } />
        <Route
          path="/help-center"
          element={
            <ProtectedRoute>
              <HelpCenter />
            </ProtectedRoute>
          }
        />

      </Routes>
    </BrowserRouter>
  );
}


export default App;